import { Button, Container, Typography } from '@mui/material'
import { HashLink } from 'react-router-hash-link'
import useStyles from '../styles/styles'
import Reveal from './Reveal'

const Home = () => {
  const classes = useStyles()
  return (
    <section id="home" className={classes.home}>
      <Container className={classes.content}>
        <Reveal>
          <Typography className={classes.eyebrow}>Full-stack software engineer</Typography>
          <Typography component="h1" className={classes.heroTitle}>I build stuff for the web.</Typography>
          <Typography className={classes.heroSubtitle}>
            Hi, I’m Mahadi. I turn ideas into dependable, user-focused web applications across the frontend and backend.
          </Typography>
          <Button component={HashLink} smooth to="/#projects" className={classes.primaryButton}>Explore work&nbsp; →</Button>
        </Reveal>
      </Container>
    </section>
  )
}

export default Home
